import React from "react";
import { useAppDispatch } from "../../redux/store";
import { RootStackParamList } from "../../types/navigationParams";
import { DrawerScreenProps } from "@react-navigation/drawer";
import { updateTimestampAction } from "../../redux/slices/authSlice";
import { Button, Text, useTheme } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { update } from "../../services/firestoreServices";
import { StyleSheet, View } from "react-native";

type Props = DrawerScreenProps<RootStackParamList, "DeleteConfirmationScreen">;

export default function DeleteConfirmationScreen({ route, navigation }: Props) {
  const { item, collection } = route.params;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const theme = useTheme();

  const deleteItem = () => {
    if (item) {
      update(collection, item.id, { ...item, deleted: true }).then(() => {
        navigation.goBack();
        navigation.goBack(); // Go back twice to return to the previous screen
      });
      dispatch(updateTimestampAction());
    }
  };

  return (
    <View style={styles.overlay}>
      <View
        style={[
          styles.container,
          {
            backgroundColor: theme.colors.background,
          },
        ]}
      >
        <View style={styles.content}>
          <Text variant="headlineSmall" style={styles.title}>
            {t("alertTitle")}
          </Text>
          <Text variant="bodyMedium" style={styles.message}>
            {t("deleteConfirmation")}
          </Text>
        </View>
        <View style={styles.actions}>
          <Button
            mode="outlined"
            onPress={() => navigation.goBack()}
            style={styles.button}
          >
            {t("Cancel")}
          </Button>
          <Button
            mode="contained"
            onPress={deleteItem}
            buttonColor={theme.colors.error}
            style={styles.button}
          >
            {t("confirmDelete")}
          </Button>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  container: {
    backgroundColor: "white",
    borderRadius: 8,
    padding: 24,
    minWidth: 300,
    maxWidth: 400,
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
  },
  content: {
    alignItems: "center",
    marginBottom: 24,
  },
  title: {
    marginBottom: 16,
    textAlign: "center",
  },
  message: {
    textAlign: "center",
    lineHeight: 24,
    marginBottom: 8,
  },
  actions: {
    flexDirection: "row",
    justifyContent: "space-around",
    gap: 16,
  },
  button: {
    flex: 1,
  },
});
